import { Column, Row, Text } from '~/commonComponents';
import { CheckSingleIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';
import CandidateSearchIcon from '~/images/perm/candidate-search-icon.svg';

export const PermanentJobsTips = () => {
  return (
    <Column
      backgroundColor={Colors.secondary_50}
      borderRadius={8}
      paddingBlock={30}
      paddingInline={35}
    >
      <Text bold color={Colors.primary_500} fontSize={18}>
        Start Receiving Qualified Candidates Today
      </Text>
      <Column gap={14} marginTop={14} marginBottom={26}>
        <Row gap={3}>
          <CheckSingleIcon color={Colors.secondary_500} />
          <Column>
            <Text>
              <Text bold>Pre-screened, qualified applicants</Text> from GoTu’s vetted dental
              network.
            </Text>
          </Column>
        </Row>

        <Row gap={3}>
          <CheckSingleIcon color={Colors.secondary_500} />
          <Column>
            <Text>
              <Text bold>Facilitated onsite interviews</Text> show you how candidates perform before
              you make a hire.
            </Text>
          </Column>
        </Row>

        <Row gap={3}>
          <CheckSingleIcon color={Colors.secondary_500} />
          <Column>
            <Text>
              <Text bold>Your job stays live for 30 days with auto-renewal</Text>, keeping you top
              of mind.
            </Text>
          </Column>
        </Row>
      </Column>
      <Row
        alignItems="center"
        backgroundColor="#D1EDF2"
        borderRadius={8}
        gap={15}
        paddingBlock={15}
        paddingInline={12}
      >
        <img src={CandidateSearchIcon} alt="candidate-search-icon" />
        <Column>
          <Text bold color={Colors.primary_500} fontSize={18}>
            The GoTu Difference
          </Text>
          <Text>
            Less searching, better choices, build a stronger, more reliable team from day one with
            GoTu.
          </Text>
        </Column>
      </Row>
    </Column>
  );
};
